import styles from './Button.module.css';

const VARIANTS = {
  primary: styles.primary,
  secondary: styles.secondary,
  ghost: styles.ghost,
  danger: styles.danger,
  terminal: styles.terminal,
};

// Reusable button. variant: primary | secondary | ghost | danger | terminal.
export default function Button({
  variant = 'primary',
  type = 'button',
  fullWidth = false,
  loading = false,
  disabled = false,
  leftIcon = null,
  rightIcon = null,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    styles.button,
    VARIANTS[variant] || VARIANTS.primary,
    fullWidth ? styles.fullWidth : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {leftIcon && <span className={styles.icon}>{leftIcon}</span>}
      {loading ? '...loading' : children}
      {rightIcon && !loading && <span className={styles.icon}>{rightIcon}</span>}
    </button>
  );
}
